import { handleInternalNavigation } from '../navigation';

export default function About() {
  return (
    <section className="mx-auto min-h-[calc(100vh-252px)] max-w-7xl items-center gap-12 px-5 py-8 md:px-8 overflow-hidden">
      <div className="awards-band-wrap w-full">
        <div className="awards-band" aria-label="Awards">
          <p className="general-header px-5 md:px-8" style={{ color: 'white', fontSize: '2.6rem', fontWeight: '400', textAlign: 'center', width: '80%'}}>
            We support Korean-American artists living and working in and outside of the United States.
          </p>
        </div>
      </div>
      <p className="general-header" style={{ fontSize: '2rem', textAlign: 'center', color: 'var(--purple-dark)', fontWeight: '700', padding: '5rem 0 0' }}>Our Mission</p>

      <p style={{ color: 'var(--purple-dark)', textAlign: 'center', lineHeight: '1.6', fontSize: '1.25rem', padding: '0 1rem' }}><span style={{ fontWeight: '700' }}>KAFA</span> was founded in 1989 and is Los Angeles’ oldest Korean-American art non-profit organization. We support creative endeavors, encourage and nurture artistic accomplishments, and acknowledge the presence of outstanding Korean-American artists in the United States.</p>

      <p style={{ color: 'var(--purple-dark)', textAlign: 'center', lineHeight: '1.6', fontSize: '1.25rem', padding: '0 1rem' }}>In June 1989, a group of art supporters in the Los Angeles area founded the Korea Arts Foundation of America (“KAFA”), a non-profit organization, to promote creativity, research, and exhibitions in the arts. KAFA aims to encourage cooperation and free exchange among those who are interested in the arts, to provide educational facilities and services for persons and organizations engaged in all forms of artistic studies, and to coordinate, plan, organize and execute art projects.</p>

      <p style={{ color: 'var(--purple-dark)', textAlign: 'center', lineHeight: '1.6', fontSize: '1.25rem', padding: '0 1rem' }}>KAFA selects one artist biennially for a $30,000 award. The purpose of the award is to facilitate creative endeavors, to enhance, encourage, and nurture artistic accomplishments, and to acknowledge the presence of outstanding Korean-American artists. Each awarded artist is required to participate in an exhibition of their work organized by KAFA in Los Angeles within one year of receiving the award. Historically, the exhibitions have been held at the Korean Cultural Center gallery in Mid-Wilshire. </p>

      <p className="general-header" style={{ fontSize: '2rem', textAlign: 'center', padding: '5rem 0 0' }}>Become a Member</p>
      <p style={{ textAlign: 'center', lineHeight: '1.6', fontSize: '1.25rem', padding: '0 1rem' }}>We love supporting exciting artists and fostering meaningful relationships.</p>

      <div className="home-hero py-8">
      <a 
        className="learn-more-button home-learn-more"
        href="/contact"
        onClick={handleInternalNavigation}
        style={{ padding: '1.05rem 1.5rem' }}
      > 
        Get in Touch 
      </a>
      </div>

      <div style={{ width: '60%', color: 'var(--purple-dark)', fontFamily: 'garamond', fontSize: '1.25rem', lineHeight: '1.6', margin: '0 auto', fontWeight: '500'}}>
        <p className="general-header" style={{ fontSize: '2rem', textAlign: 'center', padding: '3rem 0 0' }}>Executive Board (2026-2027)</p>
        <p>President:    Gloria Lee </p>
        <p>Secretary:    Frank Lee</p>
        <p>Treasurer:    Oklan Lisa Hwang</p>

        <p className="general-header" style={{ fontSize: '2rem', textAlign: 'center', padding: '3rem 0 0' }}>Board of Directors</p>
        <p>Susan Baik</p>
        <p>Hyongsok Ricky Choi</p>
        <p>Hyon Chough</p>
        <p>May Chung</p>
        <p>Thomas Han</p>
        <p>Oklan Lisa Hwang</p>
        <p>Higgin Kim</p>
        <p>Ellie Lee</p>
        <p>Frank and Ae Kyung Lee</p>
        <p>Gloria Lee and Nathan Swift</p>
        <p>Yangmi C. Lee</p>
        <p>Jungran Noh</p>

        <p className="general-header" style={{ fontSize: '2rem', textAlign: 'center', padding: '3rem 0 0' }}>Honorary Board of Directors</p>
        <p>Indong and Kyungja Oh</p>
        <p>Hak Sik and Aeza Son</p>
        <p>Jong Soo and Ilsun Kim</p>
        <p>Taewoong and Soonja Oh Kim</p>
        <p>Yungseok Kim</p>
        <p>David Lee and Miki Nam</p>
        <p>Kyu Sik and Inhee Jung</p>
        <p>Sabina Y. Lee</p>
        <p>Julia Choo</p>
        <p>Robin Kim</p>
        <p>Sook Kim</p>
        <p>Haesook Sophi Lee</p>
        <p>Wilson and Hazel Park</p>
        <p>Charles and Kay Song</p>
        <p>Yunhee Yoo</p>
        <p>June Lew</p>
      </div>

    </section>
  );
}
